import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';

export const MedicalHistoryStep = ({ formData, update }) => (
  <div className="space-y-5" data-testid="intake-step-medical">
    <h2 className="text-2xl font-bold text-darkBrown mb-2">Medical History</h2>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Current Medications</label>
      <Textarea data-testid="intake-medications" rows={3} value={formData.currentMedications} onChange={(e) => update('currentMedications', e.target.value)} placeholder="List all current medications and dosages..." className="resize-none" />
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Allergies</label>
      <Textarea rows={2} value={formData.allergies} onChange={(e) => update('allergies', e.target.value)} placeholder="List any known allergies..." className="resize-none" />
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Past Medical Diagnoses</label>
      <Textarea rows={3} value={formData.pastDiagnoses} onChange={(e) => update('pastDiagnoses', e.target.value)} placeholder="List any previous or current diagnoses..." className="resize-none" />
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Current Primary Care Physician</label>
      <Input value={formData.currentPhysician} onChange={(e) => update('currentPhysician', e.target.value)} placeholder="Dr. Name, Practice" />
    </div>
  </div>
);
